import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useBusinesses } from '@/hooks/api-hooks';
import { setWebTitle } from '@/lib/format-utils';
import FilteredBusinessesLayout from '@/components/filtered-businesses-layout';
import BulkBusinessEditModal from '@/components/business-tables/bulk-business-edit-modal';
import { Button } from '@mantine/core';

export default function BusinessessPage(): JSX.Element {
    const { t } = useTranslation();
    setWebTitle(t('businesses'));

    const [error] = useState<string | null>(null);
    const [selectedBusinesses, setSelectedBusinesses] = useState<string[]>([]);

    const { isLoading, data } = useBusinesses();
    const businesses = data?.data || [];

    return (
        <div>
            <div className="panel-content">
                {error && (
                    <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded mb-4">
                        {error}
                    </div>
                )}
                <FilteredBusinessesLayout
                    businesses={businesses}
                    isLoading={isLoading}
                    selectedIds={selectedBusinesses}
                    onSelectionChange={setSelectedBusinesses}
                    renderActions={(selectedBusinessesData, clearSelection) => (
                        <BulkBusinessEditModal
                            businesses={selectedBusinessesData}
                            onSuccess={clearSelection}
                            target={
                                <Button size="xs" radius="md" color="black">
                                    {t('operations')}
                                </Button>
                            }
                        />
                    )}
                />
            </div>
        </div>
    );
}
